import { render, staticRenderFns } from "./gigya-config.vue?vue&type=template&id=29cedaa2&scoped=true"
import script from "./gigya-config.vue?vue&type=script&lang=js"
export * from "./gigya-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cedaa2",
  null
  
)

export default component.exports